import { CurvePoolSimplified } from '../../../data/pools';
import topPoolsJSON from './top-pools.json';

export const topPools = topPoolsJSON as Array<CurvePoolSimplified>;
